// extracted by mini-css-extract-plugin
export default {"settingsModal":"styles_settingsModal__Iq0Dg","isActive":"styles_isActive__aZ5oA"};